'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const GridPhotoElement = require('./GridPhotoElement');
const { trackGridPhotoDisplay } = require('../../actions/pdpTrackingActions.es');

class GridPhoto extends React.Component {
    componentDidMount() {
        this.context.executeAction(trackGridPhotoDisplay);
    }

    render() {
        return (
            <div className="pdp-grid-photo-container">
                <div className="pdp-grid-photo-inner">
                    <h2 className="pdp-grid-photo-header">View Similar Pieces in Featured Rooms</h2>
                    <div className="pdp-grid-photo-list">
                        {this.props.photos.map((photo) => (
                            <GridPhotoElement key={ photo.id } context={ this.context } {...photo} />))}
                    </div>
                </div>
            </div>
        );
    }
}

GridPhoto.defaultProps = {
    photos: []
};

GridPhoto.propTypes = {
    context: PropTypes.object,
    photos: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired
    }))
};

GridPhoto.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func
};

module.exports = GridPhoto;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridPhoto.jsx